"use client";
import Tag from "../Tag/Tag";
import Image from "next/image";
import React from "react";
import { useDictionary } from "../DictProvider/DictProvider";
import toast from "react-hot-toast";
import { usePathname, useRouter } from "next/navigation";
import usePost from "@/hooks/usePost";
import useImageUrlModifier from "@/lib/useImageUrlModifier";

export default function ShopbyCategory({
  shopByCategory,
}: {
  shopByCategory: any;
}) {
  const dictionary = useDictionary();
  const fallbackImage = "/images/dummy-image-square.jpg";
  const modifyImageUrl = useImageUrlModifier();
  const { PostMethod, loading } = usePost();
  const router = useRouter();
  const pathname = usePathname();

  const getSubCategory = async (cat: string) => {
    try {
      let response = await PostMethod({
        method: "get",
        url: `catSubcat/subcategory/${cat}`,
      });

      if (response?.success === true) {
        if (response?.data?.length > 0) {
          router.push(
            `${pathname?.split("/")[1]}/category/${cat?.toLowerCase()}/subcategory`
          );
          return;
        }
        router.push(
          `${pathname?.split("/")[1]}/category/${cat?.toLowerCase()}`
        );
      }
    } catch (error: any) {
      toast.error(error?.message || "Something Went Wrong");
      return;
    }
  };

  return (
    <div id="category">
      <Tag yes={true} name={dictionary?.Home?.shopByCategory} />
      <div className="relative mx-7 md:mx-10 xl:mx-20">
        <div className="grid md:grid-cols-3 grid-cols-3 xs:grid-cols-4 lg:grid-cols-6 gap-8 xl:gap-14 justify-items-center place-items-center items-baseline">
          {shopByCategory?.map((item: any, index: number) => (
            <React.Fragment key={index}>
              <div
                className="cursor-pointer"
                onClick={() =>
                  getSubCategory(item?.categorySlug?.toLowerCase())
                }
              >
                <div className="flex items-center flex-col">
                  <Image
                    src={
                      modifyImageUrl(item?.catImg, 100, 100) || fallbackImage
                    }
                    alt={item?.category}
                    width={95}
                    height={95}
                    quality={100}
                    priority={true}
                    sizes="100px"
                    placeholder="blur"
                    blurDataURL={fallbackImage}
                  />
                  <p className="text-center pt-2 md:pt-6 text-sm md:text-[22px] leading-6 font-normal text-own-black">
                    {item?.category}
                  </p>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
        {loading && (
          <div className="absolute w-full h-full inset-0 flex justify-center items-center bg-white/50">
            <span className="loader"></span>
          </div>
        )}
      </div>
    </div>
  );
}
